export default __webpack_public_path__ + "static/media/Clothes- Kids.9f2f20fe.jpg";